import { ChangePlanPreview } from '@/api/api.types'

export default function getChangePlanPreviewEventEntity(planChangePreview?: ChangePlanPreview) {
  return {
    domain: 'broadband',
    sku: planChangePreview?.newPlan?.sku,
    price: stripPriceFormatting(planChangePreview?.ongoingPriceNewPlan ?? 0),
    fullPrice: stripPriceFormatting(planChangePreview?.ongoingPriceNewPlan ?? 0),
  }
}

function stripPriceFormatting(price: string | number, convertToPence = true): number {
  const conversion = convertToPence ? 100 : 1

  if (typeof price === 'string') {
    // Remove any non-numeric characters (e.g., currency symbols, commas)
    const stripped = price.replace(/[^0-9.-]+/g, '')

    return parseFloat(stripped) * conversion || 0
  }

  return price * conversion
}
